module.exports = __webpack_public_path__ + "static/media/web.1fab7856.png";